import React, {useEffect, useState} from 'react';
import styles from "./switches.module.scss";
import {useTranslation} from 'react-i18next';
import {Switch, message as messageAnt} from "antd";
import soundOn from "../../../assets/images/soundOn.png";
import soundOff from "../../../assets/images/soundOff.png";
import {useAdvisors} from "../../../hooks/advisor.hook";

interface IProps {
    setTracking: React.Dispatch<React.SetStateAction<boolean>>
}

const Switches = ({setTracking}: IProps) => {

    const {t, i18n} = useTranslation();

    const {loading, getStatusNotifications, setStatusNotifications, error, clearError} = useAdvisors()

    const [trackingForAdvisorsTrigger, setTrackingForAdvisorsTrigger] = useState<boolean>(true)//выключатель отслеживания за советником
    const [stateNotificationsTrigger, setStateNotificationsTrigger] = useState<boolean>()//выключатель уведомлений от советников

    //включение/выключение отслеживания советников
    const switchTrackingForAdvisorsHandler = (checked: boolean) => {
        setTrackingForAdvisorsTrigger(checked)
        setTracking(checked)
        if (checked) {
            messageAnt.info('Отслеживание включено')
        } else {
            messageAnt.info('Отслеживание выключено')
        }
    }
    //включение/выключение отслеживания советников (клик по label)
    const switchAdvisorsHandlerLabelClick = () => {
        const stateOfTracking = trackingForAdvisorsTrigger
        switchTrackingForAdvisorsHandler(!stateOfTracking)
    }

    //включение/выключение уведомлений от советников
    const switchNotificationsHandler = async () => {
        const stateNotifications = stateNotificationsTrigger
        try {
            const dataStatus = await setStatusNotifications(!stateNotifications)
            setStateNotificationsTrigger(!stateNotifications)
            messageAnt.info(dataStatus.message)
        } catch (e) {
            if (e instanceof Error) {
                messageAnt.error(e.message);
            }
            clearError()
        }
    }

    //функция получение статуса вкл/выкл уведомлений от советников
    const getStatusNotificationsTrigger = async () => {
        try {
            const data = await getStatusNotifications()
            messageAnt.info(data.message)
            return data.info
        } catch (e) {
            messageAnt.info(error);
            clearError()
        }
    }

    //изначальное получение статуса вкл/выкл уведомлений от советников
    useEffect(() => {
        const get = async () => {
            const status = await getStatusNotificationsTrigger()
            setStateNotificationsTrigger(status)
        }
        get()
    }, [])

    return (
        <div className={styles.container}>
            <div className={styles.content}>
                <div className={styles.blockWrap}>
                    {/*//@ts-ignore*/}
                    <p className={styles.title}>{t('AdvisorsTradingRecommendationsTitle')}</p>
                    <div className={styles.switches}>
                        <div className={styles.switchOnAdvisors}>
                            <Switch size="small" onChange={switchTrackingForAdvisorsHandler}
                                    checked={trackingForAdvisorsTrigger}/>
                            {/*//@ts-ignore*/}
                            <p onClick={switchAdvisorsHandlerLabelClick}>{t('AdvisorsSwitchTracking')}</p>
                        </div>
                        <div className={styles.switchSound} onClick={switchNotificationsHandler}>
                            {
                                stateNotificationsTrigger ?
                                    <img src={soundOn} alt=""/> :
                                    <img src={soundOff} alt=""/>
                            }
                            {/*//@ts-ignore*/}
                            <p>{t('AdvisorsSwitchAllNotifications')}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Switches;